<template>
	<div>
		<h2 class="clearfix mb-4">
			{{$t('edit-event')}}
			<div class="float-right">
				<button @click="saveEvent" class="btn btn-primary" :disabled="!event.date">{{ $t('save') }}</button>
			</div>
		</h2>
		<transition name="saved-fade">
			<div v-if="saved" class="alert alert-success mb-4">{{ $t('saved') }}</div>
		</transition>
		<div class="row mb-4">
			<div class="col-12">
                 <div class="row">
                    <DateInput
                        :label="$t('date')"
                        v-model="event.date"
                        class="col-6"
                    />

                    <NumberInput
                        :label="$t('number-of-tracks')"
                        v-model="event.numtracks"
                        class="col-3"
                    />
                    <!-- <TextInput
                        :label="$t('title')"
                        v-model="event.title"
                        class="col-6"
                    /> -->

                    <!-- <TextAreaAutosize
					:label="$t('description')"
					v-model="event.note"
					class="mb-4 col-6"
				/>  -->
                </div>
				<b-tabs pills v-model="tabIndex" content-class="mb-4 pt-2">
					<!-- <b-tab>
						<template #title>
							{{$t('forms')}}
							<span class="badge rounded-pill bg-secondary text-white" v-if="event.forms.length">{{event.forms.length}}</span>
						</template>
						<FormsPicker
							v-model="event.forms"
							:loading="loading"
						/>
					</b-tab> -->
					<b-tab>
						<template #title>
							{{$t('examiners')}}
							<span class="badge rounded-pill bg-secondary text-white" v-if="event.examiner.length">{{event.examiner.length}}</span>
						</template>
						<UserSelector
                            :value="event?.examiner"
                            :users="users.examiners"
                            :stations="osce.stations"
                            :loading="loading"
                        />
					</b-tab>
                    <b-tab>
						<template #title>
							{{$t('observers')}}
							<span class="badge rounded-pill bg-secondary text-white" v-if="event.qa.length">{{event.qa.length}}</span>
						</template>
						<UserSelector
                            :value="event?.qa"
                            :users="users.observers"
                            :stations="osce.stations"
                            :loading="loading"
                        />
					</b-tab>
                    <b-tab>
						<template #title>
							{{$t('qa-reviewers')}}
							<span class="badge rounded-pill bg-secondary text-white" v-if="event.reviewer.length">{{event.reviewer.length}}</span>
						</template>
						<UserSelector
                            :value="event?.reviewer"
                            :users="users.reviewers"
                            :stations="osce.stations"
                            :loading="loading"
                        />
					</b-tab>
                    <b-tab>
						<template #title>
							{{$t('students')}}
							<span class="badge rounded-pill bg-secondary text-white" v-if="event.students.length">{{event.students.length}}</span>
						</template>
						<!-- <UserSelector
                            :value="event?.students"
                            :users="users.students"
                            :loading="loading"
                        /> -->
                        <EventStudentEditor 
                            v-if="!loading && event.students.length >= 0" 
                            v-model="event.students" 
                            :options="users.students"
                            :showStudentIds="true" 
                        />
					</b-tab>
                    <!-- <b-tab>
						<template #title>
							{{$t('learning-outcomes')}}
							<span class="badge rounded-pill bg-secondary text-white" v-if="event.learningoutcomes.length">{{stage.learningoutcomes.length}}</span>
						</template>
						<LearningOutcomesMapper
							v-model="event.learningoutcomes"
							:loading="loading"
						/>
					</b-tab> -->

				</b-tabs>
			</div>
		</div>

		<div class="mt-4">
			<h3 class="clearfix mb-3">
				{{ $t('rotations') }}
				<div class="float-right">
					<button class="btn btn-secondary" @click="addRotation">+ {{ $t('add-rotation') }}</button>
				</div>
			</h3>
			<div class="row">
				<div class="col-md-4" v-for="(rotation, rotIndex) in event.rotations" :key="rotIndex">
					<div class="card mb-4">
						<div class="card-header d-flex justify-content-between align-items-center">
							<strong>{{ $t('rotation') }} {{ rotIndex + 1 }}</strong>
							<button class="btn btn-sm btn-secondary" @click="removeRotation(rotation)" :disabled="event.rotations.length <= 1">
								<b-icon icon="trash"></b-icon>
							</button>
						</div>
						<div class="card-body">
							<div class="row mb-3">
								<TimeInput
									:label="$t('from')"
									v-model="rotation.timefrom"
									class="col-6"
								/>
								<TimeInput
									:label="$t('to')"
									v-model="rotation.timeto"
									class="col-6"
								/>
							</div>
							<div v-for="student in studentsInRotation(rotation)" :key="student.user_id" class="d-flex justify-content-between align-items-center mb-2">
								<span>{{ student.displayname }}</span>
								<button class="btn btn-sm btn-secondary" @click="removeFromRotation(student)">
									<b-icon icon="x"></b-icon>
								</button>
							</div>
							<select class="form-control mt-2" v-if="studentsInRotation(rotation).length < (event.numtracks || Infinity)" @change="addToRotation($event, rotation)">
								<option value="">{{ $t('add-student') }}…</option>
								<option v-for="student in unassignedStudents" :key="student.user_id" :value="student.user_id">{{ student.displayname }}</option>
							</select>
							<p v-else class="text-muted small mt-2 mb-0">{{ $t('rotation-full') }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

    </div>
</template>

<script>
let _tempRotationId = 0;
//import FormsPicker from "src/components/FormResponses/FormSelector";
//import TestsPicker from "src/components/CompetencyTests/TestSelector";
//import RoleSelector from "src/components/Roles/RoleSelector";
//import TagSelector from "src/components/Tags/GroupedTagSelector";
//import YesNoToggle from "src/components/Inputs/YesNoToggle";
import TimeInput from "src/components/Inputs/TimeInput.vue";
//import LearningOutcomesMapper from "src/components/LearningOutcomes/LearningOutcomesMapper";
import UserSelector from "src/components/OSCE/UserSelector.vue";
import DateInput from "src/components/Inputs/DateInput.vue"
import NumberInput from "../../../components/Inputs/NumberInput.vue";
import EventStudentEditor from "src/components/Events/EventStudentEditor.vue";


export default {
	components: {
		//FormsPicker,
		//TestsPicker,
		//RoleSelector,
		//TagSelector,
		//YesNoToggle,
        TimeInput,
        //LearningOutcomesMapper,
        UserSelector,
        DateInput,
        NumberInput,
        EventStudentEditor
	},
    created() {
        // Give the default rotation a unique temp ID so students can be matched to it
        this.event.rotations[0].osceeventrotation_id = --_tempRotationId;
    },
	mounted() {
		Promise.all([
            this.fetchEvent(),
            this.getUsersByPriv('OSCE_EXAMINER'),
            this.getUsersByPriv('OSCE_OBSERVER'),
            this.getUsersByPriv('OSCE_QA'),
            this.getUsersByPriv('APP_STUDENT')
        ])
        .then(([event, examiners, observers, reviewers, students]) => {
            if(!event) console.warn('No event');
            this.users.examiners = examiners;
            this.users.observers = observers;
            this.users.reviewers = reviewers;
            this.users.students = students.map(x => {
               return {
                id: x.id,
                user_id: x.id,
                displayname: x.displayName,
                student_id: x.studentid,
                programme_id: x.programme,
                firm_id: x.firm,
                year: x.year,
                group_id: x.group,
            }
            });
        })
        .catch((error) => {
            console.error('Error loading data:', error);
        })
        .finally(() => {
            this.loading = false;
        });

        if(!this.$route.params.id)this.fetchOSCE()
	},
    data() {
        return {
			loading: true,
			submitting: false,
        	tabIndex: 0,
        	event: {
        		id: null,
				osce_id: this.$route.params.osceid,
        		datetimefrom: null,
                date: null,
                examiner: [],
                qa: [],
                reviewer: [],
                students: [],
                numtracks: 1,
                rotations: [{ osceeventrotation_id: null, timefrom: '', timeto: '' }]
        	},
            osce: {
                id: null,
                title: '',
                note: '',
                stations: [
                	{
                		oscestation_id: 1 ,
                		oscestation_title: "TEST"
                	}
                ],
                learningoutcomes: [],
                status: 1,
                events: []
            },
        	saved: false,

            error: {},
            users: {
                examiners: [],
                observers: [],
                reviewers: [],
                students: []
            },
            studentRotationMap: {}
        }
    },
    methods: {
    	saveEvent() {
			if (this.submitting) return
			this.submitting = true

            this.event.datetimefrom = this.event.date
			this.$store.commit('showBlockingSpinner')

			const payload = {
				...this.event,
				students: this.event.students.map(s => {
					const uid = String(s.user_id || s.id);
					const rotId = this.studentRotationMap[uid];
					// eslint-disable-next-line eqeqeq
					const idx = rotId != null ? this.event.rotations.findIndex(r => r.osceeventrotation_id == rotId) : -1;
					return { ...s, rotation_index: idx >= 0 ? idx : null };
				})
			};

			this.$cfetch(`${this.$settings.APIBaseURL}/osce/events/save`, {
  				method: 'post',
  				data: payload,
  			})
			.then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Unexpected error saving workflow event')

				this.saved = true
				setTimeout(() => { this.saved = false }, 3000)
			})
			.catch(error => {
				this.$log.error.call(this, error);
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('error-saving-event'),
				})
			})
			.finally(() => {
				this.$store.commit('hideBlockingSpinner')
				this.submitting = false
			})
    	},
    	fetchEvent() {
			if (!this.$route.params.id) return Promise.resolve()

			this.$store.commit('showBlockingSpinner')

  			return this.$cfetch(`${this.$settings.APIBaseURL}/osce/events/get`, {
  				data: {
  					id: this.$route.params.id
  				}
  			})
			.then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching event')

                // Build student-rotation map before Object.assign overwrites event.students
                // (EventStudentEditor remaps students to users.students objects, losing osceeventrotation_id)
                const newMap = {};
                (res.result.students || []).forEach(s => {
                    const uid = String(s.user_id || s.id);
                    if (s.osceeventrotation_id) newMap[uid] = s.osceeventrotation_id;
                });
                this.studentRotationMap = newMap;

                Object.assign(this.event, res.result) // reactivity was acting up

                this.event.date = this.getISODateFromTimestamp(this.event.datetimefrom)

                // Ensure at least one rotation; assign temp IDs to any without a real ID
                if (!this.event.rotations || this.event.rotations.length === 0) {
                    this.event.rotations = [{ osceeventrotation_id: --_tempRotationId, timefrom: '', timeto: '' }];
                } else {
                    this.event.rotations.forEach(r => {
                        if (!r.osceeventrotation_id) r.osceeventrotation_id = --_tempRotationId;
                    });
                }

                this.fetchOSCE()
                
			})
			.catch(error => {
				this.$log.error.call(this, error)
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('error-fetching-event'),
					confirmCallBack: function () {
						this.$router.push('/settings/osce')
					}
				})
			})
			.finally(() => {
				this.$store.commit('hideBlockingSpinner')
			})
    	},
        fetchOSCE() {
            this.$store.commit('showBlockingSpinner')

            return this.$cfetch(`${this.$settings.APIBaseURL}/osce/get`, {
                method: 'GET',
                data: { id: this.event.osce_id ? this.event.osce_id : this.$route.params.osceid }
            })
                .then(res => {
                    if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching osce')
                    Object.assign(this.osce, res.result) // Vue 2 reactivity strikes again.
                })
                .catch(error => {
                    this.$log.error.call(this, error)
					this.$store.commit('openDialog', {
						title: this.$t('something-went-wrong'),
						content: this.$t('error-fetching-event'),
						confirmCallBack: function () {
							this.$router.push('/settings/osce')
						}
					})
                })
                .finally(() => {
                    this.$store.commit('hideBlockingSpinner')
                })
        },
        getUsersByPriv(priv) {
            return this.$cfetch(`${this.$settings.APIBaseURL}/getusers`,
                {
                    method: "post",
                    data: {
                        priv: priv
                    }
                }
            )
            .then(res => {
                if (res.status == "SUCCESS") {
                	return res.users.map(user => {
                        return {
                            stations: [],
                            ...user,
                            displayname: user.displayName
                        }
                    });
                }
            })
            .catch(error => {
                this.$log.error.call(this, error);
            });
		},
        getISODateFromTimestamp(timestamp){
            let iso = new Date(Number(timestamp)*1000).toISOString().split('T')[0];
            return iso
        },
        addRotation() {
            this.event.rotations.push({ osceeventrotation_id: --_tempRotationId, timefrom: '', timeto: '' });
        },
        removeRotation(rotation) {
            if (this.event.rotations.length <= 1) return;
            Object.keys(this.studentRotationMap).forEach(uid => {
                // eslint-disable-next-line eqeqeq
                if (this.studentRotationMap[uid] != null && this.studentRotationMap[uid] == rotation.osceeventrotation_id) {
                    this.$set(this.studentRotationMap, uid, null);
                }
            });
            const idx = this.event.rotations.indexOf(rotation);
            if (idx !== -1) this.event.rotations.splice(idx, 1);
        },
        studentsInRotation(rotation) {
            return this.event.students.filter(s => {
                const uid = String(s.user_id || s.id);
                // eslint-disable-next-line eqeqeq
                return this.studentRotationMap[uid] != null && this.studentRotationMap[uid] == rotation.osceeventrotation_id;
            });
        },
        addToRotation(e, rotation) {
            const userId = e.target.value;
            if (!userId) return;
            this.$set(this.studentRotationMap, String(userId), rotation.osceeventrotation_id);
            e.target.value = '';
        },
        removeFromRotation(student) {
            this.$set(this.studentRotationMap, String(student.user_id || student.id), null);
        },
    },
    computed: {
        unassignedStudents() {
            return this.event.students.filter(s => !this.studentRotationMap[String(s.user_id || s.id)]);
        },
    },

}
</script>

<style scoped>
.saved-fade-enter-active {
    transition: opacity 0.3s;
}
.saved-fade-leave-active {
    transition: opacity 1s;
}
.saved-fade-enter,
.saved-fade-leave-to {
    opacity: 0;
}
</style>
